import React, { ReactNode } from 'react';
import { Heading3 } from '@ovotech/element-v4';
import styles from './Step.module.css';

type StepProps = {
  iconText: string;
  children: ReactNode;
};

export const Step = ({ iconText, children }: StepProps) => {
  return (
    <div className={styles.step}>
      <Heading3 className={styles.icon}>{iconText}</Heading3>
      <div className={styles.content}>{children}</div>
    </div>
  );
};
